import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-61bb1b23")

_pushScopeId("data-v-61bb1b23")
const _hoisted_1 = { class: "matrix" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        key: _ctx.identify(item),
        style: _ctx.metaWithStyle,
        class: "matrix__item"
      }, [
        _renderSlot(_ctx.$slots, "default", {
          item: item,
          index: index
        }, () => [
          _createTextVNode(_toDisplayString(item), 1)
        ], true)
      ], 4))
    }), 128)),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.additions, (item) => {
      return (_openBlock(), _createBlock("span", {
        key: item,
        class: "flex-1",
        style: _ctx.metaWithStyle
      }, null, 4))
    }), 128))
  ]))
})